import backofficeService from '../../api/backoffice'
import publicService from '../../api/public'
// let cachedonor = null
// let cacheTopdonor = null
// let cacheOutstandingBalance = null

// setInterval(() => {
//   nullEverything()
// }, 3600000);

// function nullEverything() {
//   // console.log('i was nullEverything here')
//   cachedonor = null
//   cacheOutstandingBalance = null
//   cacheTopdonor = null
// }

// window.onload = function () {

//   document.addEventListener('invoiceCreated', nullEverything)
// }
// document.addEventListener('invoiceCreated', nullEverything)


export default {
  getTuitionSponsorships(params) {
    return backofficeService.Api().get('tuitionSponsorship', { params }).then(response => response.data).catch(error => { throw error })
  },

  getTuitionAllocations(params) {
    return backofficeService.Api().get('tuitionSponsorship/allocations', { params }).then(response => response.data).catch(error => { throw error })
  },

  recordTuitionPayment(allocationId, data) {
    return backofficeService.Api().post(`tuitionSponsorship/allocations/${allocationId}/payment`, data).then(response => response.data).catch(error => { throw error })
  },
  /**
   * Get list of categories
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.assignedToUserID
   * @param {*} params.assignedToMe
   * @param {*} params.reporterUserID
   * @param {*} params.reporteredByMe
   */
  async getAll(params) {
    // if (cachedonor) return cachedonor
    return backofficeService.Api().get('donor', {
        params
      })
      .then(response => {
        // cachedonor = response.data
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  async getPaymentReqById(id, params = {}) {
    // if (cachedonor) return cachedonor
    return publicService.Api().get(`public/donor/info/${id}`, {
        params
      })
      .then(response => {
        // cachedonor = response.data
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  async readSecret(id) {
    return backofficeService.Api().get(`/donor/${id}/readSecret`)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },


  async noInvoice(params) {
    return backofficeService.Api().get('report/noInvoice/donor', {
        params
      })
      .then(response => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  async getAllCount(params) {
    return backofficeService.Api().get('donor', {
        params
      })
      .then(response => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  async sendEmail(params) {
    return backofficeService.Api().post('/email/send', params)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  async PaymentInfoMarkCollected(id, data) {
    // console.log('sending data', data)
    return publicService.Api().put(`public/donor/markCollected/${id}`, data)
      .then(response => response.data)
      .catch((error) => {
        // console.log('error updating mark collect', error)
        throw error
      })
  },


  /**
   * Update specific category
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`donor/${id}`, data)
      .then(response => {
        // nullEverything()
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  /**
   * Update specific category
   * @param {*} id
   * @param {*} data
   */
  syncBalance(id) {
    return backofficeService.Api().get(`donor/syncBalance/${id}`)
      .then(response => {
        // nullEverything()
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  create(data) {
    return backofficeService.Api().post('donor', data)
      .then(response => {
        // nullEverything()
        return response.data
      })
      .catch(error => error)
  },

  /**
   * Get specific product
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to product
   */
  getById(id, params = {}) {
    return backofficeService.Api().get(`donor/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },


  async getTopdonor(id, params = {}) {
    // if (cacheTopdonor) return cacheTopdonor
    return backofficeService.Api().get(`donor/topdonor`, {
        params
      })
      .then(response => {
        // cacheTopdonor = response.data
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  /**
   * Get outstanding balance
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to product
   */
  getOutstandingBalance(params = {}) {
    // if (cacheOutstandingBalance) return cacheOutstandingBalance
    return backofficeService.Api().get(`donor/outstandingBalance`, {
        params
      })
      .then(response => {
        // cacheOutstandingBalance = response.data
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },


  // getByTask(taskID, params) {
  //   return backofficeService.Api().get(`api/comment/byTask/${taskID}`, { params })
  //     .then(response => response.data)
  //     .catch((error) => { throw error })
  // },
  delete(id) {
    return backofficeService.Api().delete(`donor/${id}`)
      .then(response => {
        // nullEverything()
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
  recover(id) {
    return backofficeService.Api().get(`donor/recover/${id}`)
      .then(response => {
        // nullEverything()
        return response.data
      })
      .catch((error) => {
        throw error
      })
  }
}
